import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeCtx = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("dnya_theme") || "dark");
  const [mobile, setMobile] = useState(() => localStorage.getItem("dnya_mobile") === "1");

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("dnya_theme", theme);
  }, [theme]);

  useEffect(() => {
    localStorage.setItem("dnya_mobile", mobile ? "1" : "0");
  }, [mobile]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));
  const toggleMobile = () => setMobile((m) => !m);

  return (
    <ThemeCtx.Provider value={{ theme, toggle, mobile, toggleMobile }}>
      {children}
    </ThemeCtx.Provider>
  );
}

export const useTheme = () => useContext(ThemeCtx);
